import { SelectOption } from '@/components/form-components/MultiSelectCombobox'
import { RestSchemas } from '@/contexts/QueryProvider'

export type ExistingRegisteredTool = RestSchemas['Messages.Agent.ExistingRegisteredTool']

export function getModuleFilterValue(tool: ExistingRegisteredTool): string {
  return tool.moduleName?.trim() || 'Not set'
}

const buildSelectOptions = (values: string[]): SelectOption<string>[] =>
  Array.from(new Set(values.filter(Boolean)))
    .sort((a, b) => a.localeCompare(b))
    .map((value) => ({ value, label: value }))

export function getAgentToolsModuleFilterOptions(tools: ExistingRegisteredTool[]): SelectOption<string>[] {
  return buildSelectOptions(tools.map(getModuleFilterValue))
}
